import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { JobRoleDisplayComponent } from '../components/job-role-display/job-role-display.component';

@NgModule({
  declarations: [
    JobRoleDisplayComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelect2Module,
    NgxIntlTelInputModule,
    InfiniteScrollModule,
    HttpClientModule,
    AngularEditorModule
  ],
  exports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelect2Module,
    NgxIntlTelInputModule,
    InfiniteScrollModule,
    HttpClientModule,
    AngularEditorModule,
    JobRoleDisplayComponent
  ]
})

export class SharedModule { }
